export const CONFIG = {
  API: "https://api-dev.upos.vn/api/social",
  PAYMENT: "VNPAY_SANDBOX",
};
